import type { ExcIceJobV1TaskKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../../util/routing/entity-paths';

export const ICE_TASK_BASE_PATH = getResolvedPath('/clearing/vendor/ice/task');

export const getIceTaskPath: EntityPathBuilder<ExcIceJobV1TaskKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return ICE_TASK_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.taskId) {
        return undefined;
      }

      return getResolvedPath(`${ICE_TASK_BASE_PATH}/$taskId`, context.keys);
    }
  }
};

export function getIceTaskDetailPath(taskId: string | undefined) {
  if (!taskId) {
    return undefined;
  }

  return getIceTaskPath({ kind: 'detail', keys: { taskId } });
}
